import { CHANNELS_TO_FILTER, TRANSFER_ORDER_STATUS } from 'constants/constants';
import toArray from 'lodash/toArray';
import FilterComponent from '../components/Filters/FilterComponent';
import i18n from 'i18n';

const warehouseFilter = (label) => ({
  key: label === 'From warehouse' ? 'fromWarehouseId' : 'toWarehouseId',
  label,
  valueCPN: (
    <FilterComponent
      reference={{
        labelProp: 'name',
        model: 'locations',
        searchMoreKeys: ['id', 'name'],
        operator: 'contL',
        valueProp: 'id',
        labelFormat: (item) => (
          <div>{item?.name ? `${item?.name} | ${item?.code}` : item?.code}</div>
        ),
      }}
    />
  ),
});

const commonFilters = [
  {
    key: 'channel',
    label: 'Channel',
    dataSource: CHANNELS_TO_FILTER,
  },
  warehouseFilter('From warehouse'),
  warehouseFilter('To warehouse'),
];

const datePickerFilter = (key, label) => ({
  key,
  label,
  isDatePicker: true,
});

const statusFilter = {
  key: 'status',
  label: 'Transfer order status',
  dataSource: toArray(TRANSFER_ORDER_STATUS)?.map((item) => ({
    value: item.value,
    label: i18n.t(item.text),
  })),
};

export const getFilters = (status) => {
  switch (status) {
    case TRANSFER_ORDER_STATUS['AWAITING_CONFIRMATION']?.value:
      return [datePickerFilter('createdAt', 'Created time'), ...commonFilters];
    case TRANSFER_ORDER_STATUS['CONFIRMED_PICK']?.value:
      return [
        datePickerFilter('confirmedTime', 'Confirmed time'),
        ...commonFilters,
      ];
    case TRANSFER_ORDER_STATUS['SHIPPING']?.value:
      return [
        datePickerFilter('deliveredTime', 'Delivered time'),
        datePickerFilter('confirmReceivedTime', 'Confirm received time'),
        ...commonFilters,
      ];
    case TRANSFER_ORDER_STATUS['RECEIVED']?.value:
      return [
        statusFilter,
        datePickerFilter('confirmedTime', 'Confirmed time'),
        datePickerFilter('deliveredTime', 'Delivered time'),
        datePickerFilter('rejectedTime', 'Rejected time'),
        datePickerFilter(
          'transferOrderBatch.confirmReceivedTime',
          'Confirm received time',
        ),
        datePickerFilter('completedTime', 'Completed time'),
        datePickerFilter('cancelledTime', 'Cancelled time'),
        ...commonFilters,
      ];
    case TRANSFER_ORDER_STATUS['COMPLETED']?.value:
      return [
        datePickerFilter('completedTime', 'Completed time'),
        ...commonFilters,
      ];
    case TRANSFER_ORDER_STATUS['CANCELLED']?.value:
      return [
        datePickerFilter('cancelledTime', 'Cancelled time'),
        ...commonFilters,
      ];
    default:
      return [
        statusFilter,
        datePickerFilter('confirmedTime', 'Confirmed time'),
        datePickerFilter('deliveredTime', 'Delivered time'),
        datePickerFilter('rejectedTime', 'Rejected time'),
        datePickerFilter(
          'transferOrderBatch.confirmReceivedTime',
          'Confirm received time',
        ),
        datePickerFilter('completedTime', 'Completed time'),
        datePickerFilter('cancelledTime', 'Cancelled time'),
        ...commonFilters,
      ];
  }
};
